import Alpine from 'alpinejs'
import { debounce } from '../utils/utils'

export const initCollapsible = (): void => {
    Alpine.data('collapsible', (minHeight = 0, expandedState = false, animationOnInit = true) => ({
        contentHeight: minHeight ? minHeight : 0,
        active: expandedState,
        init() {
            if (animationOnInit) {
                this.$refs.content.classList.add('animate')
            }

            setTimeout(
                () => {
                    if (expandedState) {
                        this.contentHeight = this.$refs.content.scrollHeight
                    }
                },
                animationOnInit ? 600 : 100
            )

            if (!animationOnInit) {
                setTimeout(() => {
                    this.$refs.content.classList.add('animate')
                }, 100)
            }

            // If the following 5 lines of code cause bugs for elements other than the footer, we'll need to add an
            // exception for the footer here.
            this.toggleTabIndex()
            window.addEventListener(
                'resize',
                debounce(() => this.toggleTabIndex())
            )

            window.addEventListener(
                'resize',
                debounce(() => this.updateContentHeight())
            )
        },
        toggleTabIndex() {
            if (window.innerWidth < 768) {
                this.active = false
                this.contentHeight = this.active ? this.$refs.content.scrollHeight : minHeight
            } else {
                this.active = true
            }
        },
        toggle(_event = null) {
            this.active = !this.active
            this.contentHeight = this.active ? this.$refs.content.scrollHeight : minHeight
        },
        updateContentHeight(childContentHeight = 0) {
            if (this.active) {
                this.contentHeight = this.$refs.content.scrollHeight + childContentHeight
            }
        },
    }))
}
